module.exports = __webpack_public_path__ + "static/media/tc.d0160247.svg";